// extracted by mini-css-extract-plugin
module.exports = {"root":"dresses-page_root__1mebD","descriptionSection":"dresses-page_descriptionSection__24UrC","mentionSection":"dresses-page_mentionSection__2ssp_"};